// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2U59j","obliqueLineWrap":"membershipbadge_obliqueLineWrap__aHcds","obliqueLine":"membershipbadge_obliqueLine__2LpyF"};